import request from '../utils/request';

export function postBloodPressureData (){
    return request({
        url: "/wxmanager/userData/bloodPressure",
        method:'post',
    });
}

export function postBloodCacsData (){
    return request({
        url: "/wxmanager/userData/bloodCacs",
        method:'post',
    });
}

export function postBloodOxygenData (){
    return request({
        url: "/wxmanager/userData/bloodOxygen",
        method:'post',
    });
}

export function postHeartRateData (){
    return request({
        url: "/wxmanager/userData/heartRate",
        method:'post',
    });
}

export function postBloodLipidData (){
    return request({
        url: "/wxmanager/userData/bloodLipid",
        method:'post',
    });
}

export function addUserBloodData (data){
    return request({
        url: "/wxmanager/userData/addUserBloodData",
        method:'post',
        data,
    });
}

export function getUserBloodDataById (){
    return request({
        url: "/wxmanager/userData/getUserBloodDataById",
        method:'post',
    });
}
export function getAddHospGiftCards (){
    return request({
        url: "/wxmanager/userData/addHospGiftCards",
        method:'post',
    });
}
  